module.exports = __webpack_public_path__ + "static/img/new-home-s.b66e5e0d.jpg";